import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import DirectionsBikeOutlined from "@mui/icons-material/DirectionsBikeOutlined";
import KayakingOutlined from "@mui/icons-material/KayakingOutlined";
import PoolOutlined from "@mui/icons-material/PoolOutlined";
import CelebrationOutlined from "@mui/icons-material/CelebrationOutlined";
import DirectionsBoatOutlined from "@mui/icons-material/DirectionsBoatOutlined";
import FitnessCenterOutlined from "@mui/icons-material/FitnessCenterOutlined";
import DownhillSkiingOutlined from "@mui/icons-material/DownhillSkiingOutlined";
import HikingOutlined from "@mui/icons-material/HikingOutlined";
import PetsOutlined from "@mui/icons-material/PetsOutlined";
import TrainOutlined from "@mui/icons-material/TrainOutlined";
import SleddingOutlined from "@mui/icons-material/SleddingOutlined";
import ScubaDivingOutlined from "@mui/icons-material/ScubaDivingOutlined";
import ForestOutlined from "@mui/icons-material/ForestOutlined";
import KitesurfingOutlined from "@mui/icons-material/KitesurfingOutlined";
import SurfingOutlined from "@mui/icons-material/SurfingOutlined";
import DirectionsCarOutlined from "@mui/icons-material/DirectionsCarOutlined";
import ParaglidingOutlined from "@mui/icons-material/ParaglidingOutlined";
import NightsStayOutlined from "@mui/icons-material/NightsStayOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";
import MuseumOutlined from "@mui/icons-material/MuseumOutlined";
import WbSunnyOutlined from "@mui/icons-material/WbSunnyOutlined";
import NightlifeOutlined from "@mui/icons-material/NightlifeOutlined";
import LandscapeOutlined from "@mui/icons-material/LandscapeOutlined";
import AcUnitOutlined from "@mui/icons-material/AcUnitOutlined";
import BeachAccessOutlined from "@mui/icons-material/BeachAccessOutlined";
import RowingOutlined from "@mui/icons-material/RowingOutlined";
import GradeOutlined from "@mui/icons-material/GradeOutlined";
import PublicOutlined from "@mui/icons-material/Public";
import WaterOutlined from "@mui/icons-material/WaterOutlined";
import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";

/** Horse riding icon — MUI doesn't include a horse icon, so we use a custom SVG. */
const HorseRidingIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M21.5 9.5c-.28 0-.55.04-.81.1L18 7l-2.78 0c-.22-.62-.76-1.09-1.44-1.18l.52-1.87c.09-.33-.05-.68-.33-.87S13.29 3 13 3.2L11.5 4.5 10.2 3.2c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l1.8 1.8-.6 2.14H8l-1.5-2H5v2l2 2v3l-1.43 4.84c-.18.6.17 1.23.77 1.4.6.18 1.23-.17 1.4-.77L9.22 15H11l4 3v3h2v-4l-3-3 .5-2h2.14l1.35 1.35c-.01.05-.01.1-.01.15 0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.1-2.5-2.48-2.5zM21.5 12c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z" />
  </SvgIcon>
);

/**
 * Hardcoded broad categories from the header tabs (except New and Club).
 * These use the `broad` URL param, not `adventure_styles`.
 */
export const broadCategoryOptions = [
  { value: "world", label: "World wonders", Icon: GradeOutlined },
  { value: "360", label: "360°", Icon: PublicOutlined },
  { value: "land", label: "Hike", Icon: ForestOutlined },
  { value: "snow", label: "Snow", Icon: AcUnitOutlined },
  { value: "sea", label: "Sea", Icon: WaterOutlined },
];

/** Weekend option — trips with duration < 3 days. Uses `weekend=1` param. */
export const weekendOption = { value: "weekend", label: "Weekend", Icon: CalendarTodayOutlined };

/**
 * Adventure style options — ordered with most-clicked styles first.
 * Removed: climbing (merged into hiking), watersports (too generic),
 * yachting & river_cruise (merged into boat).
 */
export const adventureStyleOptions = [
  { value: "signature", label: "Signature", logo: "/new_logo/sotravel_signature_logo.png" },
  { value: "original", label: "Original", logo: "/new_logo/sotravel_original_logo.png" },
  { value: "wild", label: "Wild", logo: "/new_logo/sotravel_wild_logo.png" },
  { value: "northern_lights", label: "Northern lights" },
  { value: "horse_riding", label: "Horse riding" },
  { value: "safari", label: "Safari" },
  { value: "dog_sledding", label: "Dog sledding" },
  { value: "biking", label: "Bike" },
  { value: "kayak", label: "Kayak" },
  { value: "boat", label: "Boat" },
  { value: "festivals", label: "Festivals" },
  { value: "fitness", label: "Fitness" },
  { value: "ski", label: "Ski" },
  { value: "hiking", label: "Hike" },
  { value: "train_railtour", label: "Train railtour" },
  { value: "diving", label: "Dive" },
  { value: "snorkeling", label: "Snorkel" },
  { value: "camping", label: "Camp" },
  { value: "wakeboarding", label: "Wakeboard" },
  { value: "surfing", label: "Surf" },
  { value: "free_diving", label: "Free dive" },
  { value: "road_trips", label: "Road trips" },
  { value: "hot_air_balloon", label: "Hot air balloon" },
  { value: "seven_wonders", label: "Seven wonders" },
  { value: "museums", label: "Museums" },
  { value: "desert", label: "Desert" },
  { value: "rafting", label: "Raft" },
  { value: "party", label: "Party" },
  { value: "cave", label: "Cave" },
  { value: "winter", label: "Winter" },
  { value: "summer", label: "Summer" },
  { value: "beach", label: "Beach" },
];

export const adventureStyleLabelMap = Object.fromEntries(
  adventureStyleOptions.map((option) => [option.value, option.label])
);

export const adventureStyleIconMap = {
  northern_lights: NightsStayOutlined,
  horse_riding: HorseRidingIcon,
  safari: PetsOutlined,
  dog_sledding: SleddingOutlined,
  biking: DirectionsBikeOutlined,
  kayak: KayakingOutlined,
  boat: DirectionsBoatOutlined,
  festivals: CelebrationOutlined,
  fitness: FitnessCenterOutlined,
  ski: DownhillSkiingOutlined,
  hiking: HikingOutlined,
  train_railtour: TrainOutlined,
  diving: ScubaDivingOutlined,
  snorkeling: ScubaDivingOutlined,
  camping: ForestOutlined,
  wakeboarding: KitesurfingOutlined,
  surfing: SurfingOutlined,
  free_diving: PoolOutlined,
  road_trips: DirectionsCarOutlined,
  hot_air_balloon: ParaglidingOutlined,
  seven_wonders: AccountBalanceOutlined,
  museums: MuseumOutlined,
  desert: WbSunnyOutlined,
  rafting: RowingOutlined,
  party: NightlifeOutlined,
  cave: LandscapeOutlined,
  winter: AcUnitOutlined,
  summer: WbSunnyOutlined,
  beach: BeachAccessOutlined,
};
